module.exports = __webpack_public_path__ + "static/media/heart29.a88e33e7.svg";